import { BaseDto, OrderByValue } from '../../core';
import { ParamMap } from '@angular/router';
import { Utils } from '../../common';
import { CERTIFICATION_TYPE } from '../../shared';

export class ProductListDto extends BaseDto<ProductListDto> {
  keyword?: string;
  searchType?: string;

  salesCategories?: string[];
  displayCategories?: string[];
  brandIds?: number[];
  startSalePrice?: number;
  endSalePrice?: number;
  startSupplyRate?: number;
  endSupplyRate?: number;
  startMoq?: number;
  endMoq?: number;
  startMoa: number;
  endMoa: number;
  rocketStock?: number;
  certificationType?: CERTIFICATION_TYPE[];
  finalSaleSupplyPrice?: number;
  isCpnp?: boolean;
  orderByMatchScore?: OrderByValue;
  orderById?: OrderByValue;
  orderBySaleSupplyPrice?: OrderByValue;
  orderByBestSelling?: OrderByValue;
  orderBySort?: OrderByValue;
  orderByEnglishName?: OrderByValue;
  orderByEnglishOptionName?: OrderByValue;
  orderByMinMoa?: OrderByValue;

  setQueryParams(params: ParamMap) {
    this.init();

    if (params.has('searchType')) {
      this.searchType = params.get('searchType');
    }

    if (params.has('brandIds')) {
      const brandIds = Utils.toArray(params.getAll('brandIds'));
      this.brandIds = brandIds.map((id) => Utils.toNumber(id));
    }
    if (params.has('salesCategories')) {
      this.salesCategories = Utils.toArray(params.getAll('salesCategories'));
    }
    if (params.has('displayCategories')) {
      this.displayCategories = Utils.toArray(params.getAll('displayCategories'));
    }
    if (params.has('startSalePrice')) {
      this.startSalePrice = Utils.toNumber(params.get('startSalePrice'));
    }
    if (params.has('endSalePrice')) {
      this.endSalePrice = Utils.toNumber(params.get('endSalePrice'));
    }
    if (params.has('startSupplyRate')) {
      this.startSupplyRate = Utils.toNumber(params.get('startSupplyRate'));
    }
    if (params.has('endSupplyRate')) {
      this.endSupplyRate = Utils.toNumber(params.get('endSupplyRate'));
    }
    if (params.has('startMoq')) {
      this.startMoq = Utils.toNumber(params.get('startMoq'));
    }
    if (params.has('endMoq')) {
      this.endMoq = Utils.toNumber(params.get('endMoq'));
    }
    if (params.has('startMoa')) {
      this.startMoa = Utils.toNumber(params.get('startMoa'));
    }
    if (params.has('endMoa')) {
      this.endMoa = Utils.toNumber(params.get('endMoa'));
    }
    if (params.has('orderById')) {
      this.orderById = (params.get('orderById') as any) as OrderByValue;
    }
    if (params.has('orderByMatchScore')) {
      this.orderByMatchScore = (params.get('orderByMatchScore') as any) as OrderByValue;
    }
    if (params.has('orderBySaleSupplyPrice')) {
      this.orderBySaleSupplyPrice = (params.get('orderBySaleSupplyPrice') as any) as OrderByValue;
    }
    if (params.has('orderByBestSelling')) {
      this.orderByBestSelling = (params.get('orderByBestSelling') as any) as OrderByValue;
    }
    if (params.has('orderByMinMoa')) {
      this.orderByMinMoa = (params.get('orderByMinMoa') as any) as OrderByValue;
    }
    if (params.has('rocketStock')) {
      this.rocketStock = Utils.toNumber(params.get('rocketStock'));
    }
    if (params.has('certificationType')) {
      this.certificationType = Utils.toArray(params.getAll('certificationType'));
    }
    if (params.has('isCpnp')) {
      this.isCpnp = params.get('isCpnp') === 'true';
    }
  }

  init() {
    this.brandIds = [];
    this.salesCategories = [];
    this.displayCategories = [];
    delete this.startSalePrice;
    delete this.endSalePrice;
    delete this.startSupplyRate;
    delete this.endSupplyRate;
    delete this.startMoq;
    delete this.endMoq;
    delete this.startMoa;
    delete this.endMoa;
    delete this.orderById;
    delete this.orderByMatchScore;
    delete this.orderBySaleSupplyPrice;
    delete this.orderByBestSelling;
    delete this.orderByMinMoa;
    delete this.rocketStock;
    delete this.certificationType;
  }
}
